import React from 'react';
import { Link } from 'react-router-dom';

import Icon from '../../stateless/Icon';
import './index.scss';

const Button = ({ onClick, stroked = false, filled = false, green = false, withIcon = false, isSubmit = false, content = '', icon= '', link}) => {
  return link
  ? (
      <Link to={link} className={'button ' + (stroked ? 'stroked ' : '') + (filled ? 'filled ' : '') + (green ? 'green' : '')} type={isSubmit ? 'submit' : 'button'}>
        { withIcon &&
          <Icon icon={icon} />
        }
        {content}
      </Link>
    )
  : (
      <button
        onClick={onClick}
        className={(stroked ? 'stroked ' : '') + (filled ? 'filled ' : '') + (green ? 'green' : '')} type={isSubmit ? 'submit' : 'button'}>
        { withIcon &&
          <Icon icon={icon} />
        }
        {content}
      </button>
    );
};

export default Button;
